export default "__VITE_ASSET__7tMAFA$3__"